module.exports = __webpack_public_path__ + "assets/img/payment-methods.2f4d73e7.png";